import repository from '@/services/repository';

const resource = '/communications';

export default {
    lookup(options: any, ownerId: string, ownerTableName: string, filterObj: any) {
        const formData = new FormData();

        for (const key in options) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        for (const key in filterObj) {
            if (filterObj.hasOwnProperty(key)) {
                formData.append(key, filterObj[key]);
            }
        }

        return repository.post(`${resource}/${ownerId}/${ownerTableName}`,
            formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    update(id: number, formData: FormData) {
        return repository.post(`${resource}/${id}`, formData);
    },
    renderEmail(communicationId: string){
        return repository.get(`${resource}/RenderMail/${communicationId}`);
    }
};
